import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const changePassword = (body) => {
  return axios.post(`${BASE_URL}/api/profile/change-password`, body);
};